import axiosInstanceNode from "@/api/axiosInstanceNode";

export const handleFinalSubmit = async (
  submitHandlers,
  currentStep,
  setIsSubmitting,
  getCompanySubmitData,
  user,
  setUser
) => {
  const submit = submitHandlers[currentStep];
  if (submit) {
    const result = await submit();
    if (result === false) return;
  }
  setIsSubmitting(true);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/save-company-info`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(getCompanySubmitData),
      }
    );

    if (!response.ok) {
      console.error("Failed to save company info:", response.statusText);
    } else {
      const data = await response.json();
      setUser({
        ...user,
        isOnboarded: true,
      });
    
    }
  } catch (error) {
    console.error("Error saving company info:", error);
  } finally {
    setIsSubmitting(false);
  }
};


// set llm api key
export const updateLlmSettings = async (llmSettings) => {
  try{
    const response = await axiosInstanceNode.put('/settings/llm', llmSettings);
    return response.data;
  } catch (error) {
    console.error("Error updating llm Key:", error);
    throw error;
  }
}